/* eslint-disable react-refresh/only-export-components */
import { observer } from "mobx-react-lite";
import { FC, useEffect, useState } from "react";
import { useSearchParams } from "react-router";
import searchPageStore from "./store/searchPageStore";
import ProductCard from "../../components/ProductCard";
import { Spinner } from "../../components/ui/Spinner";
import "./searchPage.css";
import { isMobile } from "react-device-detect";
import ToggleSwitch from "../../components/ui/ToggleSwitch";
import { toJS } from "mobx";
import { Helmet } from "react-helmet-async";
import SearchPageFilters from "./components/SearchPageFilters";
import { Select } from "../../components/ui/Select";
import { ChevronLeft, ChevronRight } from "lucide-react";
const SearchPage: FC = () => {
  const [searchParams] = useSearchParams();

  const handleToggleAvailableCity = () => {
    searchPageStore.toggleAvailableInCity();
  };

  useEffect(() => {
    if (searchPageStore.isAvailableInCity) {
      searchPageStore.getAvailables();
    } else {
      searchPageStore.searchProducts(searchParams.get("search") || "");
    }
  }, [searchParams]);

  useEffect(() => {
    searchPageStore.searchProducts(searchParams.get("search") || "");
  }, [searchParams]);

  const handlePageChange = (page: number) => {
    if (searchParams.get("search")) {
      searchPageStore.searchProducts(searchParams.get("search") || "", page);
    }
  };

  const [pageInput, setPageInput] = useState("");

  const renderPagination = () => {
    if (!searchPageStore.products || searchPageStore.products.last_page <= 1) {
      return null;
    }

    const { current_page, last_page } = searchPageStore.products;

    const handlePageInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      const value = e.target.value;
      // Разрешаем только цифры
      if (value === "" || /^\d+$/.test(value)) {
        setPageInput(value);
      }
    };

    const handlePageInputSubmit = (e: React.FormEvent) => {
      e.preventDefault();
      const pageNumber = parseInt(pageInput, 10);
      if (pageNumber >= 1 && pageNumber <= last_page) {
        handlePageChange(pageNumber);
        setPageInput("");
      }
    };

    const handlePageInputBlur = () => {
      const pageNumber = parseInt(pageInput, 10);
      if (pageInput && pageNumber >= 1 && pageNumber <= last_page) {
        handlePageChange(pageNumber);
      }
      setPageInput("");
    };

    return (
       <div className="flex justify-center gap-[25px] mt-[12px] h-[30px]">
        <button className="cursor-pointer !p-0"
          onClick={() => handlePageChange(current_page - 1)}
          disabled={current_page === 1}
        >
          <ChevronLeft className={current_page === 1 ? 'text-gray-400' : 'text-[#232323]'}></ChevronLeft>
        </button>

        <form
          onSubmit={handlePageInputSubmit}
          className="flex items-center gap-[5px] font-medium text-[#232323]"
        >
          <input
            type="text"
            value={pageInput}
            onChange={handlePageInputChange}
            onBlur={handlePageInputBlur}
            placeholder={current_page.toString()}
            className="!w-[22px] text-center  bg-white !rounded-[6px] !p-0 !h-[30px] border focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
          <span className="text-[#232323]">из {last_page}</span>
        </form>
        <button 
        className="cursor-pointer !p-0"
          onClick={() => handlePageChange(current_page + 1)}
          disabled={current_page === last_page}
        >
          <ChevronRight className={current_page === last_page ? 'text-gray-400' : 'text-[#232323]'}></ChevronRight>
        </button>
      </div>
    );
  };

  // if (searchPageStore.isLoading) {
  //   return (
  //     <div className="flex justify-center items-center h-64">
  //       <Spinner size="lg" />
  //     </div>
  //   );
  // }

  // if ((!searchPageStore.isLoading && !searchPageStore.products) || searchPageStore.errorOnFetch) {
  //   return (
  //     <div className="bg-white rounded-[20px] shadow p-4 flex flex-col">
  //       <span className=" font-bold text-2xl">К сожалению, по вашему запросу ничего не найдено</span>
  //       <p>Проверьте корректность поискового запроса, он должен быть простым и конкретным, содержать название запчасти, либо артикул, например: «Фильтр» или «FC1107».</p>
  //     </div>
  //   );
  // }

  return (
    <div
      className={
        !isMobile
          ? "flex flex-row p-4 gap-4"
          : "flex flex-col p-0 items-center justify-center mt-2"
      }
    >
      {/* <nav className="flex items-center text-sm text-gray-600 mb-4">
            {path?.map((category, index) => (
              <div key={category.ref_key} className="flex items-center">
                {index > 0 && <span className="mx-2 text-gray-400"> - </span>}
                {index === path.length - 1 ? (
                  <span className="text-gray-800 font-medium">{category.name}</span>
                ) : (
                  <Link
                    to={`/category/${category.ref_key}`}
                    className="hover:text-blue-500 hover:underline"
                  >
                    {category.name}
                  </Link>
                )}
              </div>
            ))}
          </nav> */}

      {/* <Button onClick={() => searchPageStore.getAvailables()}>Показать наличие</Button> */}
      <Helmet>
        <>
          <title>КЦ Авто | поиск по запросу {searchParams.get("search")}</title>
          <meta
            name="description"
            content={`КЦ авто поиск запчастей ${searchParams.get("search")}`}
          />
          <meta
            name="keywords"
            content="КЦ Авто, интернет магазин автозапчастей, поиск запчастей, купить автозапчасти"
          />
        </>
      </Helmet>

      <SearchPageFilters></SearchPageFilters>
      {((!searchPageStore.isLoading && !searchPageStore.products) ||
        searchPageStore.errorOnFetch) && (
        <div className="bg-white rounded-[20px] shadow-[0_2px_20px_#0000001a] p-4 flex flex-col">
          <span className=" font-bold text-2xl">
            К сожалению, по вашему запросу ничего не найдено
          </span>
          <p>
            Проверьте корректность поискового запроса, он должен быть простым и
            конкретным, содержать название запчасти, либо артикул, например:
            «Фильтр» или «FC1107».
          </p>
        </div>
      )}
      {searchPageStore.isLoading && (
        <div className="flex justify-center items-center h-64 w-full">
          <Spinner size="lg" />
        </div>
      )}
      {!searchPageStore.isLoading && searchPageStore.products && (
        <div
          className={
            !isMobile ? "flex flex-col p-2" : "flex flex-col items-center"
          }
        >
          <div className="flex items-center justify-between gap-4 w-full mb-2">
            <h2
              className={
                isMobile ? "p-4" : "p-0 items-start text-left w-full mb-2"
              }
            >
              Поиск по запросу {searchParams.get("search")}
            </h2>
            {!isMobile && (() => {
              const sortOptions = [
                { value: undefined, label: "Сортировка" },
                { value: "price:asc", label: "По возрастанию цены" },
                { value: "price:desc", label: "По убыванию цены" },
                { value: "name:asc", label: "По наименованию A-Z/А-Я" },
                { value: "name:desc", label: "По наименованию Z-A/Я-А" },
              ];
              const sortValue =
                searchPageStore.sortBy && searchPageStore.sortDirection
                  ? `${searchPageStore.sortBy}:${searchPageStore.sortDirection}`
                  : "";
              return (
                <Select
                  options={sortOptions}
                  value={sortValue}
                  onChange={async (val) => {
                    const [by, dir] = String(val).split(":");
                    searchPageStore.setSort(
                      (by as "name" | "price" | ""),
                      (dir as "asc" | "desc" | "")
                    );
                    await searchPageStore.searchProducts(searchParams.get("search") || "", searchPageStore.products?.current_page);
                  }}
                  placeholder="Сортировка"
                  disabled={searchPageStore.isLoading}
                  className="min-w-[200px] h-[35px]"
                />
              );
            })()}
          </div>

          {searchPageStore.errorOnFetch ||
            (searchPageStore.products.data.length == 0 &&
              !searchPageStore.isAvailableInCity && (
                <div className="bg-white rounded-[20px] shadow p-[20px] flex flex-col">
                  <span className=" font-bold text-2xl">
                    К сожалению, по вашему запросу ничего не найдено
                  </span>
                  <p className="mt-[20px]">
                    Проверьте корректность поискового запроса, он должен быть
                    простым и конкретным, содержать название запчасти, либо
                    артикул, например: «Фильтр» или «FC1107».
                  </p>
                </div>
              ))}
          {searchPageStore.errorOnFetch ||
            (searchPageStore.products.data.length == 0 &&
              searchPageStore.isAvailableInCity && (
                <div className="bg-white rounded-[20px] shadow p-[20px] flex flex-col">
                  <span className=" font-bold text-2xl">
                    К сожалению, на странице{" "}
                    {searchPageStore.products.current_page} - нет наличий в
                    вашем городе
                  </span>
                  <p className="mt-[20px]">
                    Попробуйте перейти на другую страницу из{" "}
                    {searchPageStore.products.last_page}
                  </p>
                </div>
              ))}
          {searchPageStore.products.data.length > 0 && (
            <>
              {(() => {
                // Разделяем товары на две группы
                const currentCityProducts =
                  searchPageStore.products?.data.filter(
                    (product) => product.availableCurrentCity
                  ) || [];
                const otherCitiesProducts =
                  searchPageStore.products?.data.filter(
                    (product) => !product.availableCurrentCity
                  ) || [];

                const hasCurrentCity = currentCityProducts.length > 0;
                const hasOtherCities = otherCitiesProducts.length > 0;
                const shouldDivide = hasCurrentCity && hasOtherCities;

                // Функция для рендера сетки товаров
                const renderProductGrid = (
                  products: typeof searchPageStore.products.data,
                  startIndex: number = 0
                ) => {
                  const totalItems = products.length;
                  const itemsPerRow = {
                    base: 1,
                    sm: 2,
                    md: 3,
                    lg: 4,
                  };

                  return products.map((product, index) => {
                    const globalIndex = startIndex + index;

                    // Определяем позицию элемента
                    const isFirstInRow = {
                      base: index % itemsPerRow.base === 0,
                      sm: index % itemsPerRow.sm === 0,
                      md: index % itemsPerRow.md === 0,
                      lg: index % itemsPerRow.lg === 0,
                    };

                    const isLastInRow = {
                      base: (index + 1) % itemsPerRow.base === 0,
                      sm: (index + 1) % itemsPerRow.sm === 0,
                      md: (index + 1) % itemsPerRow.md === 0,
                      lg: (index + 1) % itemsPerRow.lg === 0,
                    };

                    const isFirstRow = index < itemsPerRow.lg;
                    const isLastRow =
                      index >=
                      totalItems -
                        (totalItems % itemsPerRow.lg || itemsPerRow.lg);

                    const borderClasses = [
                      "border-[#54545657] border-b-[1px]",
                      // Нижняя граница для всех элементов, кроме последней строки
                      isFirstRow ? "" : "",
                      isLastRow ? "!border-b-[0px]" : "",
                      // Левая граница убирается только для первого в строке
                      isFirstInRow.base ? "!border-l-0" : "border-l-[1px]",
                      // Правая граница убирается только для последнего в строке
                      isLastInRow.base ? "border-r-0" : "border-r-[1px]",
                      // Для sm экранов
                      "",
                      isFirstInRow.sm ? "sm:border-l-0" : "sm:border-l-[1px]",
                      isLastInRow.sm ? "sm:border-r-0" : "sm:border-r-[1px]",
                      // Для md экранов
                      "",
                      isFirstInRow.md ? "md:border-l-0" : "md:border-l-[1px]",
                      isLastInRow.md ? "md:border-r-0" : "md:border-r-[1px]",
                      // Для lg экранов
                      "",
                      isFirstInRow.lg
                        ? "!border-l-0 !rounded-lt-[20px]"
                        : "lg:border-l-[1px]",
                      isLastInRow.lg
                        ? "!border-r-0 !rounded-rt-[20px]"
                        : "lg:border-r-[1px]",
                    ]
                      .filter(Boolean)
                      .join(" ");

                    return (
                      <ProductCard
                        key={product.ref_key}
                        className={borderClasses}
                        product={product}
                      />
                    );
                  });
                };

                return (
                  <>
                    {shouldDivide ? (
                      <>
                        {/* Товары в текущем городе */}
                        <div
                          className={
                            "grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 rounded-[20px] bg-white " +
                            (isMobile
                              ? "bg-white rounded-[20px] w-full"
                              : "bg-white rounded-[20px] p-[6px] shadow-[0_2px_20px_#0000001a] w-[1000px]")
                          }
                        >
                          {renderProductGrid(currentCityProducts, 0)}
                        </div>

                        {/* Разделитель */}
                        <div
                          className={
                            !isMobile
                              ? "my-6 px-4 "
                              : "mt-[20px]  px-[30px] self-start"
                          }
                        >
                          <h2
                            className={
                              !isMobile
                                ? "text-[1.68rem] font-bold text-[#232323] tracking-[-0.02em]"
                                : "text-[17px] font-bold text-[#232323] text-left tracking-[-0.02em]"
                            }
                          >
                            В наличии в других городах
                          </h2>
                        </div>

                        {/* Товары в других городах */}
                        <div
                          className={
                            "grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 rounded-[20px] bg-white " +
                            (isMobile
                              ? "bg-white rounded-[20px] w-full"
                              : "bg-white rounded-[20px] p-[6px] shadow-[0_2px_20px_#0000001a] w-[1000px]")
                          }
                        >
                          {renderProductGrid(
                            otherCitiesProducts,
                            currentCityProducts.length
                          )}
                        </div>
                      </>
                    ) : (
                      // Если только одна группа - отображаем как раньше
                      <div
                        className={
                          "grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 rounded-[20px] " +
                          (isMobile
                            ? "bg-white rounded-[20px] w-full"
                            : "bg-white rounded-[20px] p-[6px] shadow-[0_2px_20px_#0000001a] w-[1000px]")
                        }
                      >
                        {renderProductGrid(
                          searchPageStore.products?.data || [],
                          0
                        )}
                      </div>
                    )}
                  </>
                );
              })()}
            </>
          )}

          {renderPagination()}
        </div>
      )}
    </div>
  );
};

export default observer(SearchPage);
